
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/service/auth.service';
import { GenericValidator } from 'src/app/validation/general-validation';
import { CompanyService } from 'src/app/service/company.service';
import { CommonService } from 'src/app/service/common.service';

@Component({
    selector: 'app-assign-company',
    templateUrl: './assign-company.component.html'
})
export class AssignCompanyComponent implements OnInit {

    successMsg: string = '';
    errorMsg: string = '';
    CompanyList: [];
    windowheight: any;
    divHeight: number;
    AssignCompanyForm: FormGroup;
    displayMessage: any;
    UserId: number;
    LoginUserId: number;
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;

    onResize() {
        this.ResizeHeight();
    }

    // Called function on initial and window resize
    ResizeHeight() {
        this.windowheight = localStorage.getItem('WindowHeight');
        this.divHeight = this.windowheight - 100;
    }

    constructor(private form: FormBuilder, private authService: AuthService, public dialogRef: MatDialogRef<AssignCompanyComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private companyservice: CompanyService, private commonservice: CommonService) {
        dialogRef.disableClose = true;
        if (data && data.UserId) {
            this.UserId = data.UserId;
        }
        this.authService.getValidationMessage().subscribe(resp => {
            this.validationMessages = resp.AssignCompanyForm;
            this.genericValidator = new GenericValidator(this.validationMessages);
        });
    }

    ngOnInit(): void {
        this.LoginUserId = +localStorage.getItem('UserId');
        this.AssignCompanyForm = this.form.group({
            CompanyId: ['', [Validators.required]]
        });

        this.GetCompanyList();
    }

    // Get Company List
    GetCompanyList() {
        this.commonservice.GetCompanyList().subscribe(
            (result) => {
                this.CompanyList = result;
                if (this.CompanyList) {
                    this.SetCompany();
                }
            },
            (error) => {
                this.errorMsg = error;
            }
        );
    }

    // Set Company
    SetCompany() {
        this.companyservice.GetCompanyIdbyUserId(this.UserId).subscribe(
            (result) => {
                this.AssignCompanyForm.patchValue({
                    CompanyId: result.Response
                });
            },
            (error) => {
                this.errorMsg = error;
            }
        );
    }

    // Assign Company
    AssignCompany() {
        if (this.AssignCompanyForm.invalid) {
            this.AssignCompanyForm.updateValueAndValidity();
            this.displayMessage = this.genericValidator.processMessages(this.AssignCompanyForm, true);
            return;
        }

        this.companyservice.AssignCompanyIdbyUserId(this.UserId, this.AssignCompanyForm.value.CompanyId, '').subscribe(
            (result) => {
                if (result.Response == 'Success') {
                    this.successMsg = 'Company assigned Successfully';
                }
                else {
                    this.errorMsg = result.Response;
                }
            },
            (error) => {
                this.errorMsg = error;
            }
        );

    }

    Close() {
        this.dialogRef.close();
    }



    // Called on change Status
    OnChangeCompany(event) {
        this.displayMessage = '';
        this.AssignCompanyForm.patchValue({
            CompanyId: event.value
        });
    }

}
